import { getUsername } from './utils/authHelper';

const username = getUsername() || '';

const COMPANY_NAME_HISTORY = `${username}.companyNameHistory`;
const ORG_NO_HISTORY = `${username}.orgNoHistory`;
const HID_HISTORY = `${username}.hidHistory`;
const ORDER_HISTORY = `${username}.orderHistory`;
const WHAT_HISTORY = `${username}.whatHistory`;

const getHistory = history => JSON.parse(localStorage.getItem(history)) || [];

const addToHistory = (historyName, item) => {
    const history = getHistory(historyName);

    const newHistory = history.reduceRight((result, nxt) => {
        if (nxt !== item) {
            result.unshift(nxt);
        }
        return result;
    }, []);

    newHistory.unshift(item);

    localStorage.setItem(historyName, JSON.stringify(newHistory.slice(0, 10)));
};

const addCompanyNameHistory = item => addToHistory(COMPANY_NAME_HISTORY, item);
const getCompanyNameHistory = () => getHistory(COMPANY_NAME_HISTORY);

const addOrgNoHistory = item => addToHistory(ORG_NO_HISTORY, item);
const getOrgNoHistory = () => getHistory(ORG_NO_HISTORY);

const addHidHistory = item => addToHistory(HID_HISTORY, item);
const getHidHistory = () => getHistory(HID_HISTORY);

const addOrderHistory = item => addToHistory(ORDER_HISTORY, item);
const getOrderHistory = () => getHistory(ORDER_HISTORY);

const addWhatHistory = item => addToHistory(WHAT_HISTORY, item);
const getWhatHistory = () => getHistory(WHAT_HISTORY);

const clearHistory = () => {
    localStorage.setItem(COMPANY_NAME_HISTORY, JSON.stringify([]));
    localStorage.setItem(ORG_NO_HISTORY, JSON.stringify([]));
    localStorage.setItem(HID_HISTORY, JSON.stringify([]));
    localStorage.setItem(ORDER_HISTORY, JSON.stringify([]));
    localStorage.setItem(WHAT_HISTORY, JSON.stringify([]));
};

const api = {
    addCompanyNameHistory,
    getCompanyNameHistory,
    addOrgNoHistory,
    getOrgNoHistory,
    addHidHistory,
    getHidHistory,
    addOrderHistory,
    getOrderHistory,
    addWhatHistory,
    getWhatHistory,
    clearHistory,
};

export default api;
